<template>
  <v-container
    class="d-flex justify-center align-center"
    fluid
    style="height: 100vh; background: linear-gradient(to bottom, #e3f2fd, #bbdefb);"
  >
    <v-card
      class="pa-4 login-card"
      elevation="12"
      style="max-width: 400px; width: 100%; border-radius: 12px; display: flex; flex-direction: column; justify-content: space-between;"
    >
      <v-card-title class="text-center" >
        <h1 class="title text-primary" style="display: inline;">Welcome to DSS</h1>
        <v-icon
            color="primary"
            size="40"
            style="display: inline; margin-left: 10px; bottom: 10px;"
          >
            mdi-tooth
          </v-icon>
      </v-card-title>
      <v-card-text style="flex: 1; ">
        <p class="text-center mb-3" style="color: #757575; font-size: 0.8rem;">
          Smarter Smiles Start Here <strong> AI-Powered CRM <v-icon class="shining" color="#F3C623">mdi-creation</v-icon></strong><br>for Modern Dental Practices.
        </p>
        
        <v-form v-model="isFormValid">
          <v-text-field
            prepend-icon="mdi-home"
            label="Client ID"
            variant="outlined"
            v-model="client_id"
            class="mb-3"
            :rules="[v => !!v || 'Client ID is required', v => /^\d+$/.test(v) || 'Only digits allowed']"
          ></v-text-field>
          <v-text-field
            prepend-icon="mdi-account"
            label="Username"
            variant="outlined"
            v-model="username"
            class="mb-3"
            :rules="RULES.REQUIRED_FIELD('User Name')"
          ></v-text-field>
          <v-text-field
            id="password"
            prepend-icon="mdi-key-variant"
            label="Password"
            type="password"
            variant="outlined"
            v-model="password"
            class="mb-3"
            :rules="RULES.REQUIRED_FIELD('Password')"
            @keydown.enter="checkLogin"
          ></v-text-field>
          <v-btn
            class="forgot-password-btn text-capitalize font-weight-medium"
            variant="text"
            @click="redirectToPasswordResetPage"
            block
            style="font-size: 0.8rem;"
          >
            Forgot your password?
          </v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          rounded
          color="primary"
          @click="checkLogin"
          dark
          large
          style="font-size: 0.9rem;"
          block
          :disabled="!isFormValid"
        >
          SIGN IN
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import {RULES} from '../constants/validationRules.js'

export default {
  name: "LogIn",
  data() {
    return {
      username: "",
      password: "",
      client_id: "",
      isFormValid : false,
      RULES
    };
  },
  methods: {
    ...mapActions(["logIn"]),
    checkLogin() {
      this.logIn({
        client_id: this.client_id,
        username: this.username,
        password: this.password,
      }).catch((msg) => {
         console.error(msg);
      });
    },
    redirectToPasswordResetPage() {
      this.$router.push("/password/reset");
    },
  },
};
</script>

<style scoped>

.title {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}


.forgot-password-btn {
  color: #1976d2;
}

.forgot-password-btn:hover {
  text-decoration: underline;
}


.shining {
  animation: shine 3s infinite;
}

.login-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 90vh;
  padding: 16px;
  overflow-y: auto;
}

/* Mobile Responsiveness */
@media (max-width: 600px) {
  .title {
    font-size: 1.5rem;
  }
  .login-card {
    padding: 12px;
  }
}
</style>